// ===================================
// VOICE API SERVICE - Stage A v2 Update
// src/services/voiceApi.js
// Added: vapiCallId parameter for updateCallStatus
// ===================================

import api from './api';

/**
 * Start a web voice call
 * Returns: 
 *   Browser mode: { success, mode: 'browser', session }
 *   VAPI mode: { success, mode: 'vapi', assistantConfig, session }
 */
export const startWebCall = async (sessionId) => {
  const response = await api.post('/voice/start-web-call', { sessionId });
  return response.data;
};

/**
 * End a web voice call
 * @param sessionId - Session ID
 * @param callId - VAPI call ID (optional)
 * @param transcript - Array of messages (optional, for browser mode)
 */
export const endWebCall = async (sessionId, callId = null, transcript = null) => {
  const response = await api.post('/voice/end-web-call', { 
    sessionId, 
    callId,
    transcript 
  });
  return response.data;
};

/**
 * Get call status
 */
export const getCallStatus = async (sessionId) => {
  const response = await api.get(`/voice/call-status/${sessionId}`);
  return response.data;
};

/**
 * Update call status
 * UPDATED: Added vapiCallId parameter
 */
export const updateCallStatus = async (sessionId, callStatus, callEvent = null, vapiCallId = null) => {
  const response = await api.post('/voice/update-call-status', {
    sessionId,
    callStatus,
    callEvent,
    vapiCallId  // <-- Add this
  });
  return response.data;
};

/**
 * Get voice configuration
 */
export const getVoiceConfig = async () => {
  const response = await api.get('/voice/config');
  return response.data;
};

/**
 * Generate voice token for web client
 */
export const generateVoiceToken = async (sessionId) => {
  const response = await api.post('/voice/generate-token', { sessionId });
  return response.data;
};

export default {
  startWebCall,
  endWebCall,
  getCallStatus,
  updateCallStatus,
  getVoiceConfig,
  generateVoiceToken
};